import { href, navigate } from '../../lib/router';
import { useToast } from '../../ui/Toasts';
import { useOwnsBusiness } from '../business/context';
import { useCanSubmit, useSubmitAssessment } from './api';

/**
 * Finishing an assessment. A business on its own finishes in one click and goes to its report (task 105,
 * decision 0074): it can start a new check any time, so there is nothing to confirm. Handing it to an
 * insurer is sent to someone else, so that keeps its confirming click on the assessment page.
 */
export function useFinish(id: string) {
  const own = useOwnsBusiness();
  const canSubmit = useCanSubmit();
  const submit = useSubmitAssessment(id);
  const toast = useToast();
  const run = async () => {
    try {
      await submit.mutateAsync();
      toast(own ? 'Finished. Here is your report.' : 'Submitted to your insurer', 'ok');
      if (own) navigate(href.report());
    } catch (err) {
      toast(err instanceof Error ? err.message : 'Could not submit', 'bad');
    }
  };
  return { own, canSubmit, run, pending: submit.isPending };
}
